import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationGaitAssistiveDevice extends React.Component {

    render() {
        let dropdownOptions = [
            { id: 'None', value: 'None' },
            { id: 'Straight Cane (SC)', value: 'Straight Cane (SC)' },
            { id: 'Quad Cane (QC)', value: 'Quad Cane (QC)' },
            { id: 'Crutches', value: 'Crutches' },
            { id: 'Loftstrand Crutches', value: 'Loftstrand Crutches' },
            { id: 'Hemiwalker', value: 'Hemiwalker' },
            { id: 'Rolling Walker (RW)', value: 'Rolling Walker (RW)' },
            { id: 'Standard Walker', value: 'Standard Walker' }
        ];

        return (
            <div className={styles.dropdown_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Gait - Assistive Device' />
                <label className={styles.label}>Assistive Device</label>
                <DBDropDownObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOGAIASSISTDEV'
                    className={styles.dropdown}
                    customOptions={dropdownOptions}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIASSISTDEV ? true : false
    };
}

const connectedObservationGaitAssistiveDevice = connect(mapStateToProps)(ObservationGaitAssistiveDevice);
export { connectedObservationGaitAssistiveDevice as ObservationGaitAssistiveDevice };


